module.exports = __webpack_public_path__ + "img/logo-idea.1e3a47b3.png";